precision highp float;

uniform float time;
varying float vAlpha;
varying float vRandom;

float hash(vec2 p) {
  return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123);
}

float noise(vec2 p) {
  vec2 i = floor(p);
  vec2 f = fract(p);

  float a = hash(i);
  float b = hash(i + vec2(1.0, 0.0));
  float c = hash(i + vec2(0.0, 1.0));
  float d = hash(i + vec2(1.0, 1.0));

  vec2 u = f * f * (3.0 - 2.0 * f);

  return mix(a, b, u.x) + (c - a) * u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

float fbm(vec2 p) {
  float v = 0.0;
  float amp = 0.5;
  for (int i = 0; i < 3; i++) {
    v += amp * noise(p);
    p *= 2.0;
    amp *= 0.5;
  }

  return v;
}

float questionMarkSDF(vec2 p) {
  vec2 arcPos = p - vec2(0.0, 0.18);
  float r = length(arcPos);

  float arcOuter = abs(r - 0.18) - 0.06;
  float arcCut = mix(-1.0, arcPos.x, step(arcPos.y, -0.05));
  float arc = max(arcOuter, arcCut);

  float centralBar = max(abs(p.x) - 0.06, abs(p.y + 0.02) - 0.12);
  float dotDist = length(p - vec2(0.0, -0.38)) - 0.07;

  return min(min(arc, centralBar), dotDist);
}

void main() {
  vec2 uv = (0.5 - gl_PointCoord) * 1.1;

  float d = questionMarkSDF(uv);
  float charMask = smoothstep(0.02, -0.02, d);

  vec2 ncoord = uv * 3.0;
  float n = fbm(ncoord + vec2(time * 0.05 + vRandom * 10.0, time * 0.02));

  float alpha = charMask * (0.8 + 0.2 * n) * vAlpha * 0.8;

  if (alpha < 0.05) discard;

  vec3 dark = vec3(0.1, 0.12, 0.15);
  vec3 light = vec3(0.4, 0.45, 0.5);
  vec3 col = mix(dark, light, clamp(vRandom * 0.7 + 0.1, 0.0, 1.0));

  gl_FragColor = vec4(clamp(col, 0.0, 1.0), clamp(alpha * 0.8, 0.0, 1.0));
}